// extracted by mini-css-extract-plugin
export default {"ta-head":"ta-head___saTyC","ta-search__input":"ta-search__input___QRBe_","ta-content":"ta-content___QuTLw"};